










import { Component, Prop, Vue } from 'vue-property-decorator';
import uuid from 'uuid/v4';

@Component({})
export default class MiddleEllipsisText extends Vue {
​
  @Prop({ type: String, default: '' }) public ellipsisText!: string;
  @Prop({ type: String, default: 'ltr' }) public dirText!: string;
  @Prop({ type: Number, default: 200 }) public textWidth!: number;
  @Prop({ type: String, default: '.' }) public divider!: string;

  private lastWord = '';
  private showLastPart = true;
  private ellipsisId: string = '';

  private created() {
    this.ellipsisId = 'ellipsis' + uuid();
  }

  private mounted() {
    const firstPartWidth = document.getElementById(this.ellipsisId)!.clientWidth;
    this.showLastPart = firstPartWidth > this.textWidth;
    const lastIndex = this.ellipsisText.lastIndexOf(this.divider) - 3;
    this.lastWord = this.ellipsisText.substring(lastIndex);
  }

}
